
  import ProfileImageRow from '@/components/candidate/ProfileImage/ProfileImageRow';

  export default {
    name: 'ProfileImagesPortrait',
    components: {
      ProfileImageRow,
    },
    data() {
      return {
        routePortrait:
          process.env.NUXT_ENV_API_PROFILE_IMAGES_PORTRAIT_ENDPOINT,
      };
    },
    computed: {
      profileImagePortrait() {
        return this.$auth.user.candidateProfile.profileImagePortrait;
      },
    },
  };
